import Vue from 'vue';
import VModal from 'vue-js-modal/dist/ssr.nocss';
import 'vue-js-modal/dist/styles.css';
// dynamicName: original vue-js-modal doesn't have this props
// Vue.use(VModal, { dynamicName: '$vmodal', dynamicDefaults: { adaptive: true, scrollable: true, height: 'auto' } })
Vue.use(VModal, {
  dynamicDefaults: { adaptive: true, scrollable: true, height: 'auto' },
});
